import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.match.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import UrlParse from 'url-parse';
import { CDN_PRISMIC_DEPRECATED, CDN_PRISMIC, CDN_MDM, MEDIA_PATH } from '~/const/images';

function formatImage(imageUri, formats, folder) {
  var datas = {};
  Object.entries(formats).forEach(function (arr) {
    var pathImage = {};
    pathImage[arr[0]] = "//www.maisonsdumonde.com/uploads/".concat(folder, "/").concat(arr[1], "/").concat(imageUri, " ").concat(arr[1], "w");
    Object.assign(datas, pathImage);
  });
  return datas;
}

function formatImageCloudinary(imageUri) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'q_auto,f_auto';
  var folder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'image';

  if (!imageUri) {
    return '';
  }

  return ["".concat(MEDIA_PATH, "/").concat(folder, "/upload"), defaultParams].concat(_toConsumableArray(params), [new UrlParse(imageUri).pathname.substr(1)]).join('/');
}

function formatPrismicImage(imageUri, params, defaultParams) {
  var folder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'image';
  var newUri = '';

  if (imageUri) {
    // Check if prismic media come from old URL
    var regex = /(\W|^)images\.prismic.io(\W|$)/g;

    if (!imageUri.match(regex)) {
      newUri = imageUri.replace(CDN_PRISMIC_DEPRECATED, "//".concat(CDN_MDM, "/prismic/"));
    } else {
      newUri = unescape(imageUri).replace(CDN_PRISMIC, "//".concat(CDN_MDM, "/prismic-imgix/"));
    }
  }

  return formatImageCloudinary(newUri, params, defaultParams, folder);
}

function getImageUrl(product) {
  // eslint-disable-next-line no-underscore-dangle
  if (product.__typename === 'CustomizableProductType') {
    var soMeImage = "https://medias.maisonsdumonde.com/q_auto/w_375,dpr_1.3/canape-so-me/".concat(product.reference, "-C-1.png");
    return {
      src: soMeImage,
      srcset: soMeImage
    };
  }

  if (product.images && product.images[0]) {
    var _product$images$ = product.images[0],
        src = _product$images$.src,
        srcset = _product$images$.srcset;
    return {
      src: src,
      srcset: srcset
    };
  }

  return {
    src: '',
    srcset: ''
  };
}

export { formatImage, formatImageCloudinary, formatPrismicImage, getImageUrl };